import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Grid, Panel, Table, Icon, Button, Row, Col, ControlLabel, Input } from 'rsuite'
import pathname from '../../constants/pathname'
import AppContext from '../../context/AppContext'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { downloadFileManual, downloadFileManualPath } from '../../redux/actions/formDownloads'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function FormDownLoadsTable({ schema, hiddenDepartment }) {
  const [sortColumn, setSortColumn] = useState()
  const [sortType, setSortType] = useState()
  const [loading, setLoading] = useState(false)
  const [formSchema, setFormSchema] = useState()
  const [inputValueName, setInputValueName] = useState('')
  const { Column, HeaderCell, Cell } = Table

  useEffect(() => {
    setFormSchema(schema)
  }, [])

  const getData = () => {
    if (sortColumn && sortType) {
      return formSchema.sort((a, b) => {
        let x = a[sortColumn]
        let y = b[sortColumn]
        if (typeof x === 'string') {
          x = x.charCodeAt()
        }
        if (typeof y === 'string') {
          y = y.charCodeAt()
        }
        if (sortType === 'asc') {
          return x - y
        } else {
          return y - x
        }
      })
    }
    return formSchema
  }

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      setSortColumn(sortColumn)
      setSortType(sortType)
    }, 500)
  }

  const onDownload = async (fileObj) => {
    console.log(fileObj)
    startLoading()
    setLoading(true)

    try {
      var file = await downloadFileManual(fileObj.id)
      // var file = await downloadFileManualPath(fileObj.filePath)

      downloadFile(file, fileObj.documentName)
      // previewFile(file, fileObj.documentName)
    } catch (e) {
      console.log('Error => ', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setLoading(false)
    doneLoading()
  }

  const onViewMedia = async (rowData) => {
    const a = document.createElement('a')
    a.href = `${rowData.link}`
    a.target = '_blank'
    document.body.appendChild(a)
    a.style.display = 'none'
    a.click()

    document.body.removeChild(a)
  }

  const onDownloadOle = async (fileObj) => {
    if (fileObj) {
      const a = document.createElement('a')
      if (fileObj.fileType === 'mp4') {
        a.href = `${fileObj.link}`
      } else {
        a.href = `../asset/${fileObj.folder}/${fileObj.documentName}.${fileObj.fileType}`
      }

      if (fileObj.fileType === 'pdf' || fileObj.fileType === 'mp4') {
        a.target = '_blank'
      }

      document.body.appendChild(a)
      a.style.display = 'none'
      a.click()

      document.body.removeChild(a)
    }
  }

  const handleChangFileName = (fileName) => {
    setInputValueName(fileName)
  }

  const handleSearchFile = () => {
    let result = []
    setLoading(true)

    if (schema.length > 0) {
      schema?.map((item) => {
        if (item?.documentName?.match(inputValueName)) {
          result.push(item)
        }
      })
    }

    setLoading(false)
    setFormSchema(result)
  }

  return (
    <>
      {loading && <OverlayLoader />}

      <Grid fluid>
        <Row style={{ padding: 10 }}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Row>
              <Col lg={5} md={12} sm={24} xs={24}>
                <ControlLabel>
                  {`${schema[0]?.fileType === 'mp4' ? 'ชื่อสื่อการสอน' : 'ชื่อเอกสาร'}`}
                </ControlLabel>
                <Input
                  name={'projectcode'}
                  value={inputValueName}
                  // defaultValue={inputValueCode}
                  onChange={handleChangFileName}
                ></Input>
              </Col>
              <Col lg={5} md={12} sm={24} xs={24}>
                <div>
                  <br />
                  <Button
                    size="sm"
                    color="green"
                    appearance="ghost"
                    style={{ width: '40%', height: '35px' }}
                    onClick={handleSearchFile}
                  >
                    ค้นหา
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    size="sm"
                    color="yellow"
                    appearance="ghost"
                    style={{ width: '40%', height: '35px' }}
                    onClick={() => {
                      setInputValueName('')
                      setFormSchema(schema)
                    }}
                  >
                    ยกเลิก
                  </Button>
                </div>
              </Col>
            </Row>
            <br />
            <Table
              // height={520}
              autoHeight
              data={getData()}
              sortColumn={sortColumn}
              sortType={sortType}
              onSortColumn={handleSortColumn}
              loading={loading}
            >
              <Column width={90} align="center" sortable>
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell dataKey="no" />
              </Column>

              <Column minWidth={600} width={480} flexGrow={1} sortable>
                <HeaderCell>ชื่อ</HeaderCell>
                <Cell dataKey="documentName">
                  {(rowData) => {
                    return (
                      <div>
                        <Icon
                          icon={rowData?.iconName || ''}
                          style={{ paddingRight: 20, color: rowData?.iconColor || '' }}
                          size="lg"
                        />
                        {`${rowData.documentName}`}
                      </div>
                    )
                  }}
                </Cell>
              </Column>

              {hiddenDepartment && (
                <Column width={180} align="center" sortable>
                  <HeaderCell>สำนัก</HeaderCell>
                  <Cell dataKey="department" />
                </Column>
              )}

              {/* <Column width={200} align="center" sortable>
                <HeaderCell>แก้ไขล่าสุด</HeaderCell>
                <Cell dataKey="lastUpdate" />
              </Column> */}

              {/* <Column width={120} align="center">
                <HeaderCell>ขนาดไฟล์</HeaderCell>
                <Cell dataKey="fileSize" />
              </Column> */}

              <Column width={130} align="center" fixed="right">
                <HeaderCell></HeaderCell>

                <Cell>
                  {(rowData) => {
                    if (rowData.fileType === 'mp4') {
                      return (
                        <Button
                          appearance="link"
                          onClick={() => {
                            // window.open(`${rowData.link}, _blank`)
                            onViewMedia(rowData)
                          }}
                        >
                          <Icon icon="play" style={{ paddingRight: 5 }} size="lg" />
                          แสดง
                        </Button>
                      )
                    }
                    return (
                      <Button
                        appearance="link"
                        onClick={() => {
                          onDownload(rowData)
                        }}
                      >
                        <Icon icon="cloud-download" style={{ paddingRight: 5 }} size="lg" />
                        โหลดไฟล์
                      </Button>
                    )
                  }}
                </Cell>
              </Column>
            </Table>
          </Col>
        </Row>
      </Grid>
    </>
  )
}
